// src/directives/trustedHtml.ts
import type { Directive } from 'vue'

export const trustedHtmlDirective: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    el.innerHTML = binding.value ?? '' // nosec
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) el.innerHTML = binding.value ?? '' // nosec
  }
}
